import { Component, OnDestroy, OnInit, ViewChild, Inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, Platform } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { BalanceModel } from 'src/app/models/balance-model';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { WithdrawalBaseComponent } from '../cashier/withdraw/withdrawal-base/withdrawal-base.component';
import { LogoutService } from "src/app/services/logout/logout.service";
import { debounceTime, Subscription } from 'rxjs';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';
import { SiteContentModel } from 'src/app/models/sitecontent-model';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import { Browser } from '@capacitor/browser';
//import { BankConnectAuth } from 'capacitor-plugin-webauth-session';
import { isUndefined } from 'src/app/services/codeUtils';

@Component({
    selector: 'app-cooling-off',
    templateUrl: './cooling-off.component.html',
    styleUrls: ['./cooling-off.component.scss'],
})
export class CoolingOffComponent extends WithdrawalBaseComponent implements OnInit, OnDestroy {

    @ViewChild('Content', { read: IonContent }) content: IonContent;

    iUnderstandButtonDisabled: boolean = false;
    public error = null;

    public accountBalances: BalanceModel;

    public withdrawalAccounts: Array<any> = [];
    // public payoutMethods: Array<any> = [];
    public selectedAccount: any;

    public withdrawalForm: FormGroup;
    public accountList: AbstractControl;
    public amount: AbstractControl;
    public currency_code: AbstractControl;

    public name: string;
    public address1: string;
    public address2: string;
    public city: string;
    public province: string;
    public postalCode: string;
    public stateEnvironment: string;

    public echeckEnabled: boolean = true;
    public offerWithdrawalFlag: boolean;
    public environmentName: string;
    private backButtonSubscribtion: Subscription;
    public labels: SiteContentInterface;
    public selectedCountry;
    public currencyLabel = 'USD';
    public canWithdrawCoolOffMethodsArray: Array<any> = [];
    public withdrawalAccountsFinalList: Array<any> = [];

    public hasVenmoDeposit: boolean = false;
    public faf_methods;

    public newWindow: any;
    public vipWithdrawWidgetURL: any;

    constructor(
        private withdrawService: WithdrawalService,
        private cashierService: CashierService,
        private events: EventsService,
        private logoutService: LogoutService,
        private navigator: Navigator,
        private balanceProvider: AccountBalanceService,
        public successMessageService: SuccessMessageService,
        public platform: Platform,
        private config: ConfigService,
        private siteContentService: SiteContentService,
        @Inject('IOS_WEB_AUTH_SESSION') private webAuthSession: any
    ) {
        super();

        this.labels = new SiteContentModel();
        this.events.publish("event:lobby:hide");
        if (this.platform.is('ipad') && this.platform.is('capacitor')) {
            this.events.publish("event:bottommenu:hide");
        }
        this.successMessageService.clearMessage();
        this.error = null;

        const appConfigInfo = this.config.getConfig();
        this.offerWithdrawalFlag = appConfigInfo.coolingoff_withdrawal;
        this.stateEnvironment = appConfigInfo.env;
    }

    ngOnInit() {

        if (this.config.getConfig().ECHECKSELECT_ENABLED == '0') {
            this.echeckEnabled = false;
        }

        this.faf_methods = this.config.getConfig().FEATURE_COOLOFF_FAF_METHODS || "";
        this.faf_methods = this.faf_methods.split(',');
        this.selectedCountry = this.config.getConfig().FEATURE_SITE_COUNTRY_REGION ? this.config.getConfig().FEATURE_SITE_COUNTRY_REGION : 'USA';
        if (this.selectedCountry === "CANADA") {
            this.currencyLabel = "CAD"
        }
        this.backButtonSubscribtion = this.platform.backButton.subscribeWithPriority(101, () => {
            if (this.navigator.getActivePage() == 'CoolingOffPage') {
                this.closeModal();
            } else {
                this.navigator.back();
            }
        });

        const canWithdrawCoolOffMethods = this.config.getConfig().FEATURE_COOLOFF_WITHDRAWAL_METHOD_LIST ?? "CAGE,VEN,GP,PPD,SL,MZACH,PWB,INSTA,IDS,GDIE,CH,PAIBT,VI,MC,PV";
        this.canWithdrawCoolOffMethodsArray = canWithdrawCoolOffMethods.split(',');

        this.withdrawalForm = new FormGroup(
            {
                amount: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
                currency_code: new FormControl(''),
                accountList: new FormControl('', [Validators.required]),
            }
        )

        this.accountList = this.withdrawalForm.get('accountList');
        this.amount = this.withdrawalForm.get('amount');
        // this.cashierProvider.getPayoutMethods().subscribe((res) => {
        //     this.payoutMethods = res;
        // });


        Promise.all(
            [this.getDepositAccounts()]).then(function (values) { }
            );
        this.environmentName = this.config.getConfig().env;
    }

    ngOnDestroy() {
        if (this.backButtonSubscribtion) {
            this.backButtonSubscribtion.unsubscribe();
        }
    }

    ionViewDidEnter() {
        this.successMessageService.clearMessage();

        this.onGetBalance();

        this.name = this.withdrawService.customer.firstName + " " + this.withdrawService.customer.lastName;
        this.address1 = this.withdrawService.customer.address.street;
        this.address2 = this.withdrawService.customer.address.street2;
        this.city = this.withdrawService.customer.address.city;
        this.province = this.withdrawService.customer.address.state;
        this.postalCode = this.withdrawService.customer.address.postalCode;
    }

    onGetBalance() {

        this.balanceProvider.getBalance().subscribe(
            (balance: BalanceModel) => {
                if (balance) {
                    this.accountBalances = balance;
                }
            }
        );
        this.error = null;
    }

    onWithdraw() {
        this.successMessageService.clearMessage();
        this.error = null;

        const data: any = {};
        data.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;
        data.amount = this.withdrawalForm.value.amount;

        const formValues = this.withdrawalForm.value.accountList.split(',');
        data.payment_type_code = formValues[0];
        data.customerAccountID = formValues[1];

        const ptc = data?.payment_type_code;

        if (ptc == 'CAGE') {
            data.isCagePayout = true;
        }

        if (this.faf_methods.includes(ptc)) {
            data.payment_type_code = "FAF";
        }

        if (ptc == 'PV') return this.callWithdrawV2(data);

        this.withdrawService.callWithdraw(data).subscribe({
            next: (response: any) => {
                // this.logger.log("callWithdraw response = ", response);
                if (response && !!response.result) {
                    this.content.scrollToTop();

                    // send the withdrawal event
                    const depositEventData: AffiliateTrackerCallbackParams = {
                        customer_id: this.withdrawService.customer.customerId,
                        amount: this.withdrawalForm.get('amount').value,
                        transaction_id: response.payload.payoutID
                    }
                    setTimeout(() => this.events.publish('event:withdraw', depositEventData), 2000);

                    this.amount.setValue('');
                    this.amount.markAsPristine();
                    this.successMessageService.setMessage('Your withdrawal request has been received.');
                    this.balanceProvider.updateBalance();
                }
            },
            error: (error) => {
                this.content.scrollToTop();
                this.error = this.handleError(error);
            }
        })

        this.error = null;
    }

    private callWithdrawV2(data) {
        this.vipWithdrawWidgetURL = this.config.getConfig().FEATURE_VIP_WITHDRAW_WIDGET_URL;

        this.withdrawService.callWithdrawV2(data).subscribe({
            next: (response: any) => {
                // if (response && !!response.result) {
                //     this.content.scrollToTop();

                //     const depositEventData: AffiliateTrackerCallbackParams = {
                //         customer_id: this.withdrawService.customer.customerId,
                //         amount: this.withdrawalForm.get('amount').value,
                //         transaction_id: response.payload.payoutID
                //     }
                //     setTimeout(() => this.events.publish('event:withdraw', depositEventData), 2000);

                //     this.amount.setValue('');
                //     this.amount.markAsPristine();
                //     this.successMessageService.setMessage('Your withdrawal request has been received.');
                //     this.balanceProvider.updateBalance();
                // }

                        if (response && !!response.result) {
                            this.content.scrollToTop();
                          let depositEventData: AffiliateTrackerCallbackParams = {
                            customer_id: this.cashierService.customer.customerId,
                            amount: this.withdrawalForm.get('amount').value
                          }
                
                
                          if (!isUndefined(response) && !!response.result) {
                            // this.paymentRequestID = response.payload.paymentRequestID;
                            let sessionId = response.payload.parameters.sessionId;
                
                            if (!this.isMobileApp()) {
                              let w: any = window;
                              this.newWindow = w.open("about:blank", "_system");
                              this.newWindow.document.write(
                                "<style> body{ background:var(--ion-color-secondary);!important;  position: relative;} div.container { margin: 0;position: absolute;top: 50%;left: 50%;-ms-transform: translate(-50%, -50%); transform: translate(-50%, -50%);color: white;font-family: roboto;font-size: 1.5em; }</style>"
                              );
                              this.newWindow.document.write(
                                "<body><div class='container'>LOADING...</div></body>"
                              );
                            }
                            // this.navigator.dismissAll();
                            let vipWidgetUrl = this.vipWithdrawWidgetURL ? this.vipWithdrawWidgetURL + sessionId : undefined;
                
                            if (this.isMobileApp() && vipWidgetUrl) {
                              return this.handleMobileView(vipWidgetUrl)
                            } else {
                              this.newWindow.location = vipWidgetUrl;
                            //   this.disableWithdrawButton = false;
                
                
                                this.newWindow.focus();
                            }
                          }
                        //   setTimeout(() => this.events.publish('event:withdraw', depositEventData), 2000);
                
                          this.successMessageService.setMessage('Your withdrawal request has been received.');
                
                          this.balanceProvider.updateBalance();
                
                          this.content.scrollToTop();
                        //   this.disableWithdrawButton = false;
                          this.amount.setValue('');
                          this.amount.markAsPristine();
                          this.error = null;
                          this.successMessageService.setMessage('Your withdrawal request has been received.');
                        //   this.withdrawalForm.reset();
                        }
            }, error: (error) => {
                this.content.scrollToTop();
                this.error = this.handleError(error);
            }
        });
    }

    isMobileApp() {
        return this.platform.is("capacitor");
    }

    private isAndroidApp() {
        return this.platform.is("capacitor") && this.platform.is("android");
    }

    private isIosApp() {
        return this.platform.is("capacitor") && this.platform.is("ios");
      }

    private async handleMobileView(vipWidgetUrl) {
        if(this.isAndroidApp()) {  
          await Browser.open({
            url: vipWidgetUrl
          });
        } else if(this.isIosApp()) {
          this.webAuthSession.startSession({
            urlString: vipWidgetUrl,
            returnUrlScheme: 'mohegansunnj-play'
          }).then(result => {
            console.log("Session completed", result);
          })
          .catch(error => {
            console.error("Session failed", error);
          });
        }
        // this.disableWithdrawButton = false;
      }

    getDepositAccounts() {
        return new Promise((resolve, reject) => {
            this.cashierService.callListAccounts().subscribe({
                next: (response: any) => {
                    if (response && !!response.result) {
                        // - We will not offer Check option here
                        if (this.isEnabled('CHECK_ENABLED')) {
                            this.withdrawalAccounts.push({ 'paymentTypeCode': 'CH' });
                        }

                        if (this.isEnabled('CASINOCAGE_ENABLED')) {
                            this.withdrawalAccounts.push({ 'paymentTypeCode': 'CAGE' });
                        }

                    if (this.isEnabled('FEATURE_COOLOFF_PAVILION')) {
                            const pavillionAccnts = response.payload
                            .filter(account => account.paymentTypeCode === "PV")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });
                            if (pavillionAccnts.length > 0) {
                                const newArr: any = { 'paymentTypeCode': 'PV' };
                                newArr.values = pavillionAccnts;
                                this.withdrawalAccounts.push(newArr);
                            }
                           
                        }

                        const achVIPAccounts = response.payload
                            .filter(account => account.paymentTypeCode === "GP")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (achVIPAccounts.length > 0) {
                            //this.withdrawalAccounts['GP'] = achVIPAccounts;
                            const newArr: any = { 'paymentTypeCode': 'GP' };
                            newArr.values = achVIPAccounts;
                            this.withdrawalAccounts.push(newArr);
                        }


                        const paypalAccounts = response.payload
                            .filter(account => account.paymentTypeCode === "PPD")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (paypalAccounts.length > 0) {
                            const newArr: any = { 'paymentTypeCode': 'PPD' };
                            newArr.values = paypalAccounts;
                            this.withdrawalAccounts.push(newArr);
                        }

                        const prepaidAccounts = response.payload
                            .filter(account => account.paymentTypeCode === "SL")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (prepaidAccounts.length > 0) {
                            const newArr: any = { 'paymentTypeCode': 'SL' };
                            newArr.values = prepaidAccounts;
                            this.withdrawalAccounts.push(newArr);
                        }

                        const eSelectAccounts = response.payload
                            .filter(account => account.paymentTypeCode === "MZACH")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (eSelectAccounts.length > 0) {
                            const newArr: any = { 'paymentTypeCode': 'MZACH' };
                            newArr.values = eSelectAccounts;
                            this.withdrawalAccounts.push(newArr);
                        }

                        // PayWithMyBank (Online Banking by Trustly)
                        const pwmbAccounts = response.payload
                            .filter(account => account.paymentTypeCode === "PWB")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (pwmbAccounts.length > 0) {
                            const newArr: any = { 'paymentTypeCode': 'PWB' };
                            newArr.values = pwmbAccounts;
                            this.withdrawalAccounts.push(newArr);
                        }

                        //InstaDebit 
                        const instaDebitAccount = response.payload
                            .filter(account => account.paymentTypeCode === "INSTA")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (instaDebitAccount.length > 0) {
                            const newArr: any = { 'paymentTypeCode': 'INSTA' };
                            newArr.values = instaDebitAccount;
                            this.withdrawalAccounts.push(newArr);
                        }

                        //iDebit 
                        const iDebitAccount = response.payload
                            .filter(account => account.paymentTypeCode === "IDS")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (iDebitAccount.length > 0) {
                            const newArr: any = { 'paymentTypeCode': 'IDS' };
                            newArr.values = iDebitAccount;
                            this.withdrawalAccounts.push(newArr);
                        }

                        //Interac 
                        const interacAccount = response.payload
                            .filter(account => account.paymentTypeCode === "GDIE")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (interacAccount.length > 0) {
                            const newArr: any = { 'paymentTypeCode': 'GDIE' };
                            newArr.values = interacAccount;
                            this.withdrawalAccounts.push(newArr);
                        }

                        //Venmo
                        this.hasVenmoDeposit = false;
                        const venmoAccount = response.payload
                            .filter(account => account.paymentTypeCode === "VEN" && account.dpstCnt > 0)
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (venmoAccount.length > 0) {
                            const newArr: any = { 'paymentTypeCode': 'VEN' };
                            newArr.values = venmoAccount;
                            this.hasVenmoDeposit = true;
                            this.withdrawalAccounts.push(newArr);
                        }

                        //Instant Bank Transfer
                        const paibtAccount = response.payload
                            .filter(account => account.paymentTypeCode === "PAIBT")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (paibtAccount.length > 0) {
                            const newArr: any = { 'paymentTypeCode': 'PAIBT' };
                            newArr.values = paibtAccount;
                            this.withdrawalAccounts.push(newArr);
                        }


                        //Check if config FEATURE_COOLOFF_WITHDRAWAL_METHOD_LIST has paymentTypeCode which we can show for CoolOff
                        const tempholdWithdrawalAccounts: any = this.withdrawalAccounts;
                        let i = 0;
                        for (const index in tempholdWithdrawalAccounts) {
                            for (let i = 0; i < this.canWithdrawCoolOffMethodsArray.length; i++) {
                                if (tempholdWithdrawalAccounts[index].paymentTypeCode == this.canWithdrawCoolOffMethodsArray[i]) {
                                    i++;
                                    this.withdrawalAccountsFinalList.push(tempholdWithdrawalAccounts[index]);
                                }
                            }

                        }
                    }
                    resolve(true);
                },
                error: error => {
                    reject(); throw new Error("Calling list-accounts webservice returns error: " + error);
                }
            });
        });
    }
    private isEnabled(vendorEnabled) {
        return this.config.getConfig()[vendorEnabled] == '1';
    }

    closeModal = () => {
        this.logoutService.onLogout({ reason: 'COOLOFF_EXIT' });
    }
}
